import { CoachingExplanation }
  from "@/components/coaching/CoachingExplanation";
import { CoachingSectionCard }
  from "@/components/coaching/CoachingSectionCard";

export const WorkoutPurposeCard = ({ explanation, error }) => {
  const isEmpty = !error && (!explanation
                                    || (explanation.message_keys || []).length === 0);
  return (
    <CoachingSectionCard
      title="Why this workout"
      subtitle="Deterministic, source-grounded"
      headingId="coaching-purpose-heading"
      testId="coaching-purpose-card"
      error={error}
      empty={isEmpty ? "Purpose unavailable for today." : null}
      elevated
    >
      {!isEmpty && (
        <CoachingExplanation
          explanation={explanation}
          testId="purpose-explanation"
        />
      )}
    </CoachingSectionCard>
  );
};
